<template>
  <div class="container-fluid py-3">
    <form class="needs-validation" @submit.prevent>
      <div class="row">

        <!-- Левая секция: Существующие перемещения -->
        <div class="col-6 border-right">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="text-dark font-weight-bold mb-0">Существующие перемещения</h5>
            <button
                type="button"
                class="btn btn-danger btn-sm"
                @click="deleteLastMovement"
                :disabled="geoMovementsData.length === 0 || isLoading"
            >
              Удалить последнее перемещение
            </button>
          </div>

          <div class="border rounded p-3 bg-white shadow-sm h-100">
            <div class="row font-weight-bold text-muted border-bottom pb-2 mb-2">
              <div class="col-1">ID</div>
              <div class="col-2">Дата</div>
              <div class="col-2">Кол-во</div>
              <div class="col-3">С Объекта</div>
              <div class="col-4">На Объект</div>
            </div>

            <div v-if="geoMovementsData.length > 0">
              <div
                  v-for="item in geoMovementsData"
                  :key="'mov-' + item.id"
                  class="row py-2 align-items-center border-bottom text-break"
              >
                <div class="col-1 font-weight-bold">{{ item.id }}</div>
                <div class="col-2 small text-secondary">{{ item.operation_date }}</div>
                <div class="col-2">{{ item.value }}</div>

                <div class="col-3">
                  {{ item.donorLocation ? item.donorLocation.name : '—' }}
                  <small v-if="item.donorLocation && item.donorLocation.id" class="text-muted d-block">
                    (id={{ item.donorLocation.id }})
                  </small>
                </div>
                <div class="col-4">
                  {{ item.acceptorLocation ? item.acceptorLocation.name : '—' }}
                  <small v-if="item.acceptorLocation && item.acceptorLocation.id" class="text-muted d-block">
                    (id={{ item.acceptorLocation.id }})
                  </small>
                </div>
              </div>
            </div>
            <div v-else class="text-center text-muted py-3">
              Перемещения отсутствуют
            </div>
          </div>
        </div>

        <!-- Правая секция: Кнопка возврата на склад -->
        <div class="col-6">
          <h5 class="mb-3 text-dark font-weight-bold">Действие</h5>

          <div class="border rounded p-4 bg-light d-flex flex-column align-items-center justify-content-center shadow-sm h-100" style="min-height: 250px;">
            <p class="text-muted text-center mb-4">
              Мат. единица сейчас находится на объекте. Вы можете оформить её возврат на центральный склад компании.
            </p>
            <button
                type="button"
                class="btn btn-warning btn-lg px-5 font-weight-bold text-dark"
                @click="openReturnModal"
                :disabled="isAlreadyInStockroom || isLoading"
            >
              <i class="fas fa-undo-alt mr-2"></i> Вернуть на склад
            </button>
          </div>
        </div>

      </div>
    </form>

    <!-- Подключение модалки подтверждения даты -->
    <unit-geo-return-move-modal
        :is-open="isReturnModalOpen"
        :unit-id="currentUnitId"
        :location-id="currentLocationId"
        @close="isReturnModalOpen = false"
        @returned="onUnitReturned"
    />
  </div>
</template>

<script>
import axios from "axios";
import UnitGeoReturnMoveModal from "./UnitGeoReturnMoveModal.vue";

export default {
  name: "unit-geo-return-movements",
  components: {
    UnitGeoReturnMoveModal
  },
  data() {
    return {
      isLoading: false,
      isReturnModalOpen: false,
      currentUnitId: null,
      currentLocationId: null,
      geoMovementsData: []
    }
  },
  computed: {
    // Автоматическая блокировка кнопки, если последняя запись указывает на Склад
    isAlreadyInStockroom() {
      if (this.geoMovementsData.length === 0) {
        return true;
      }
      const lastMovement = this.geoMovementsData[0];

      // Блокируем кнопку, если вложенный объект назначения имеет системный код склада 'stockroom'
      return lastMovement.acceptorLocation && lastMovement.acceptorLocation.code === 'stockroom';
    }
  },
  methods: {
    getGeoMovementsData(unitId) {
      this.currentUnitId = unitId;
      this.isLoading = true;
      let uri = `/v1/units/get-geo-movements-with-actors`;
      axios
          .get(uri, { params: { id: unitId } })
          .then(resp => {
            this.geoMovementsData = resp.data || [];
          })
          .catch(err => {
            const errorMsg = err.response && err.response.data && err.response.data.message
                ? err.response.data.message : "Ошибка запроса истории";
            if (this.$store) {
              this.$store.dispatch("addNotification", { text: errorMsg, time: 6, color: "danger" });
            }
          })
          .finally(() => { this.isLoading = false; });
    },

    openReturnModal() {
      if (this.geoMovementsData.length === 0) return;

      const lastMovement = this.geoMovementsData[0];

      if (!lastMovement || !lastMovement.acceptorLocation || !lastMovement.acceptorLocation.id) {
        if (this.$store) {
          this.$store.dispatch("addNotification", { text: "Не удалось определить текущий объект мат. единицы", time: 4, color: "warning" });
        }
        return;
      }

      this.currentLocationId = lastMovement.acceptorLocation.id;
      this.isReturnModalOpen = true;
    },

    onUnitReturned() {
      // 1. Свежие данные прилетят с сервера, в массив встанет запись со 'stockroom', и computed свойство заблокирует кнопку
      this.getGeoMovementsData(this.currentUnitId);
      // 2. Оповещаем stockroom.vue для перерисовки главной таблицы
      this.$emit("unit-geo-moved");
    },

    deleteLastMovement() {
      if (this.geoMovementsData.length === 0 || !this.currentUnitId) return;

      if (confirm("Вы уверены, что хотите безвозвратно удалить последнее перемещение?")) {
        this.isLoading = true;
        let uri = `/v1/units/delete-last-geo-movement`;
        axios
            .post(uri, { unit_id: this.currentUnitId })
            .then(resp => {
              this.geoMovementsData.shift();
              this.$emit("unit-geo-moved");
              if (this.$store) {
                this.$store.dispatch("addNotification", { text: resp.data.message || "Перемещение удалено", time: 4, color: "success" });
              }
            })
            .catch(err => {
              const errorMsg = err.response && err.response.data && err.response.data.message
                  ? err.response.data.message : "Не удалось удалить перемещение";
              if (this.$store) {
                this.$store.dispatch("addNotification", { text: errorMsg, time: 6, color: "danger" });
              }
            })
            .finally(() => { this.isLoading = false; });
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
